import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useConfig } from '../../../hooks/use-config';
import * as PricingConstants from './../helpers/constant';
import { getPriceString } from '../helpers/helpers';

const initialState = {
  creditErrorMessage: '',
};

const CreditCalculator = ({
  creditValue,
  onCalculatorValueChange,
  currency,
  billingPrice,
  selectedSlab,
}) => {
  const [state, setState] = useState(initialState);
  const { clearout: clearoutConfig } = useConfig();

  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])


  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      creditErrorMessage: '',
      creditValue,
    }));
  }, [creditValue, selectedSlab]);

  const onFocusOut = () => {
    setState((prevState) => ({
      ...prevState,
      creditErrorMessage: '',
    }));
  };

  const onCreditValChange = (e) => {
    const inputValue = e.target.value.trim();
    let val = 0;

    if (!isNaN(inputValue) && inputValue.length <= 8) {
      val = e.target ? e.target.value : 0;
      val = val > PricingConstants.MAX_CREDIT_BUY ? PricingConstants.MAX_CREDIT_BUY : val;

      setState((prevState) => ({
        ...prevState,
        creditValue: val,
        creditErrorMessage: val <= PricingConstants.MAX_CREDIT_BUY ? "" :
          "For more than 20 million credits or custom requirement, please contact us on chat or mail us at us@clearout.io"
      }));

      onCalculatorValueChange(val); // Call the calculator change function after setting the state
    } else {
      val = e.target ? e.target.value : 0;
      if (val > PricingConstants.MAX_CREDIT_BUY) {
        setState((prevState) => ({
          ...prevState,
          creditErrorMessage: "For more than 20 million credits or custom requirement, please contact us on chat or mail us at us@clearout.io"
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          creditValue: val,
          creditErrorMessage: ""
        }));
        onCalculatorValueChange(val); // Ensure this runs even if the value is below the limit
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === '.' || e.key === 'e') {
      e.preventDefault()
    }
  }

  return (
    <div className="credit-calculator">
      <h3 style={{ marginBottom: 0 }}>Calculate Your Cost</h3>
      <div className="col m-auto pt-4 d-flex justify-content-center flex-column align-items-center">
        <Form.Control
          id="credits-input"
          className="credit-input mb-2"
          type="number"
          value={state.creditValue}
          onBlur={onFocusOut}
          ref={inputRef}
          onChange={onCreditValChange}
          onKeyDown={handleKeyDown}
          placeholder="Enter number of credits"
        />
        <p className="error-message">{state.creditErrorMessage}</p>
      </div>
      <div className="col-sm-12 pt-2 pb-3">
        <div className="pricing-text-div mb-1" key={state.creditValue}>
          <p className="pricing-text text-center">
            Buy&nbsp;
            <span className="price-selected">
              {Number(state.creditValue).toLocaleString(PricingConstants.CURRENCY.USD.locale)}
            </span>
            &nbsp;credits for&nbsp;
            <span className="price-selected notranslate">
              {getPriceString({ price: billingPrice, currency: currency })}
            </span>
          </p>
        </div>
      </div>
      <div>
        <div className="col-12 m-auto d-flex flex-column">
          <button
            className="purchase-btn-text btn btn-primary btn-md mb-1 pay-as-yo-go-btn"
            onClick={() => {
              window.open(clearoutConfig.app.registerUrl, '_blank')
            }}
            style={{ cursor: 'pointer' }}
          >
            <span>Get 100 Free Credits</span><br />
            <span className="try-now-underline-text">Try Now</span>
          </button>



        </div>
        <div>
          <span style={{ fontSize: '13px' }}>No Credit Card Required</span>
        </div>
      </div>
    </div>
  );
};

export default CreditCalculator;
